export default __webpack_public_path__ + "static/apple-icon-120x120-6dead67bda75a7d9af0f6232b1315361.png";